<template>
  <hr class="my-3">
  <div
      class="flex flex-wrap pc:mx-[100px]"
  >
    <div
        v-for="(spaceImg, photoIndex) in spacePhotoModelValue"
        :key="picUrl + photoIndex"
        class="w-1/2 sm:w-full px-[10px] mb-4"
        @click="handleSpacePhoto(route.params.spaceid)"
    >
      <NuxtImg
          class="rounded-[5%] w-full"
          format="webp"
          quality="90"
          sizes="sm:100vw md:500px"
          loading="lazy"
          :src="picUrl + spaceImg.url"
          :alt="spaceImg.description ? spaceImg.description : spaceNameModelValue"
      />
    </div>
  </div>

  <hr class="my-3">
</template>

<script setup
        lang="ts">
import {ref} from "vue";

const picUrl = ref(import.meta.env.VITE_APP_BASE_IMG_URL)
const router = useRouter()
const route = useRoute();
const spacePhotoModelValue = defineModel('spacePhotoObj', {type: Object, default: {}})
const spaceNameModelValue = defineModel('spaceName', {type: String, default: ''})


const handleSpacePhoto = (spaceid) => {
  router.push({path: `/admin-photo/${spaceid}`})
}
</script>

<style scoped
       lang="scss">

</style>
